import { render } from "./BadgesAsPartButtons.vue?vue&type=template&id=69c41c7c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__